export default __webpack_public_path__ + "static/media/punto-de-venta.90ffdd97.jpg";